import { render, staticRenderFns } from "./firstPage.vue?vue&type=template&id=af194094&scoped=true&"
import script from "./firstPage.vue?vue&type=script&lang=js&"
export * from "./firstPage.vue?vue&type=script&lang=js&"
import style0 from "./firstPage.vue?vue&type=style&index=0&id=af194094&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af194094",
  null
  
)

export default component.exports